import useSetupConfigurationContext from "./useSetupConfigurationContext";

export default useSetupConfigurationContext;
